import request from "@/untils/request.js"

/**
 * 随访管理记录表 - 分页查询
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} params.startTime - 开始时间 (yyyy-MM-dd)
 * @param {string} params.endTime - 结束时间 (yyyy-MM-dd)
 * @param {number} params.status - 状态: 1未执行 2执行中 3执行完成 4超期
 * @param {string} params.patientName - 患者名称(模糊搜索)
 */
export function followPage(params) {
    return request({
        url: '/outpatient/follow/page',
        method: 'get',
        params: params
    })
}

/**
 * 随访管理记录表 - 获取详情
 * @param {number} id - 随访记录ID
 */
export function followDetail(id) {
    return request({
        url: `/outpatient/follow/${id}`,
        method: 'get'
    })
}

export const followAdd = (data) => {
    return request.post("/outpatient/follow", data)
}

export const followExeRecord = (data) => {
    return request.post("/outpatient/follow/exeRecord", data)
}

export const followUpdate = (data) => {
    return request.put("/outpatient/follow", data)
}

export const getFollowDetailById = (id) => {
    return request.get(`/outpatient/follow/followDetail/${id}`)
}

